import { put } from 'redux-saga/effects';
import { AxiosResponse } from 'axios';

import {
	addToSnapshots,
	getSnapshots,
	loadMoreSnapshots,
	removeFromSnapshots,
} from './service';
import {
	getSnapshotsSuccessAction,
	getSnapshotsFailureAction,
	removeFromSnapshotsSuccessAction,
	loadMoreSnapshotsSuccessAction,
} from './action';
import {
	getChartCounterSuccessAction,
	setChartCounterAction,
} from '../ChartCounter/action';
import { editSnapFailureAction, editSnapSuccessAction } from '../Snaps/action';

export function* getSnapshotsSaga() {
	try {
		const { data }: AxiosResponse = yield getSnapshots();
		const { snapshots, counter, page, totalPages } = data.data;
		yield put(getSnapshotsSuccessAction({ snapshots, page, totalPages }));
		yield put(getChartCounterSuccessAction(counter));
	} catch (e) {
		yield put(getSnapshotsFailureAction(e as Error));
	}
}

export function* removeFromSnapshotsSaga(action: any) {
	const { _id, callback } = action.payload;
	try {
		const { data }: AxiosResponse = yield removeFromSnapshots(_id);
		yield put(removeFromSnapshotsSuccessAction(_id));
		yield put(editSnapSuccessAction(data.data));
		yield put(setChartCounterAction({ snapshots: -1 }));
	} finally {
		yield callback && callback();
	}
}

export function* addToSnapshotsSaga(action: any) {
	const { _id, callback } = action.payload;
	try {
		const { data }: AxiosResponse = yield addToSnapshots(_id);
		yield put(editSnapSuccessAction(data.data));
		yield put(setChartCounterAction({ snapshots: +1 }));
	} catch (e) {
		yield put(editSnapFailureAction(e as Error));
	} finally {
		yield callback && callback();
	}
}

export function* loadMoreSnapshotsSaga(action: any) {
	const { payload } = action;

	try {
		const { data }: AxiosResponse = yield loadMoreSnapshots(payload);

		yield put(loadMoreSnapshotsSuccessAction(data.data));
	} catch (e) {
		yield put(getSnapshotsFailureAction(e as Error));
	}
}
